import React from 'react';
import { Head } from '@inertiajs/react';
import PostList from '@/components/admin/blog/PostList';

interface Post {
  id: number;
  title: string;
  slug: string;
  summary: string;
  cover_image: string;
  status: 'draft' | 'published' | 'archived';
  visibility: 'visible' | 'auth_only';
  published_at: string | null;
  created_at: string;
  updated_at: string;
  author: {
    id: number;
    name: string;
    email: string;
  };
  categories: Array<{ id: number; name: string; slug: string }>;
  tags: Array<{ id: number; name: string; slug: string }>;
}

interface Props {
  posts: Post[];
}

const Index: React.FC<Props> = ({ posts }) => {
  return (
    <>
      <Head title="Blog Posts" />
      <PostList posts={posts} canCreate={true} canEdit={true} canDelete={false} />
    </>
  );
};

export default Index;
